import { ApiPathConfig } from '../../api/api-path-config';
import {
  PublicTermsOverviewApiResponse,
  PublicTermDetailsApiResponse,
} from '../../api/responses/api-response-types';
import { dispatchableGet } from '../../api/redux-fetch';
import { pagesSlice, pageDetailsSlice } from './slices';

export const fetchPublicPages = () => {
  return dispatchableGet<PublicTermDetailsApiResponse>({
    url: ApiPathConfig.publicTermsIndex,
    onSuccess: pagesSlice.actions.success,
    onLoading: pagesSlice.actions.loading,
    onError: pagesSlice.actions.error,
  });
};

export const fetchPageDetails = (url: string) => {
  return dispatchableGet<PublicTermsOverviewApiResponse>({
    url,
    onSuccess: pageDetailsSlice.actions.success,
    onLoading: pageDetailsSlice.actions.loading,
    onError: pageDetailsSlice.actions.error,
  });
};
